// Lightweight CSV helpers + paginated fetch-all for analytics exports.

export function toCsv(columns, rows) {
  const esc = (v) => {
    if (v === null || v === undefined) return "";
    const s = String(v);
    return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const cell = (col, row) => esc(typeof col.value === "function" ? col.value(row) : row[col.key]);
  const head = columns.map((c) => esc(c.label)).join(",");
  const body = rows.map((r) => columns.map((c) => cell(c, r)).join(",")).join("\n");
  return head + "\n" + body;
}

export function downloadCsv(filename, csv) {
  const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function stamp() {
  return new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-");
}

// Page through a paginated analytics endpoint and return every matching row.
export async function fetchAllRows(api, path, params = {}, { cursor = false } = {}) {
  const rows = [];
  if (cursor) {
    let after = null;
    for (let i = 0; i < 50; i++) {
      const p = new URLSearchParams({ ...params, limit: "100", ...(after ? { starting_after: after } : {}) });
      const { data } = await api.get(`${path}?${p}`);
      rows.push(...(data.rows || []));
      if (!data.has_more || !data.next_cursor) break;
      after = data.next_cursor;
    }
  } else {
    const p = new URLSearchParams({ ...params, page: "1", page_size: "5000" });
    const { data } = await api.get(`${path}?${p}`);
    rows.push(...(data.rows || []));
  }
  return rows;
}
